import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

const TCGS = [["pokemon", "Pokémon"], ["one_piece", "One Piece"], ["altro", "Altri TCG (community)"]];
const MODES = [["shipping", "Spedizione"], ["in_person", "Incontro di persona"]];

export default function Onboarding() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [tcgs, setTcgs] = useState([]);
  const [modes, setModes] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggle = (arr, set, v) => set(arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);

  const finish = async (goCards) => {
    setLoading(true);
    try {
      await api.post("/settings/onboarding", { preferred_tcgs: tcgs, trade_modes: modes });
      await refresh();
      nav(goCards ? "/le-mie-carte" : "/dashboard");
    } catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-xl">
      <h1 className="font-display text-3xl font-bold text-[#F8FAFC]">Benvenuto in Omniverse</h1>
      <p className="mt-2 text-[#CBD5E1]">Due passaggi veloci per personalizzare la tua esperienza. Puoi saltarli e completarli più tardi.</p>

      <div className="mt-6 space-y-5">
        <div className="rounded-2xl border border-[#2A3655] bg-[#141B2D] p-5">
          <h2 className="font-display font-semibold text-[#F8FAFC]">1. Scegli i TCG di interesse</h2>
          <div className="mt-3 flex flex-col gap-2">
            {TCGS.map(([v, l]) => (
              <label key={v} className="flex items-center gap-2 text-sm text-[#CBD5E1]" data-testid={`onb-tcg-${v}`}>
                <Checkbox checked={tcgs.includes(v)} onCheckedChange={() => toggle(tcgs, setTcgs, v)} className="border-[#2A3655] data-[state=checked]:bg-[#7C3AED]" />{l}
              </label>
            ))}
          </div>
        </div>
        <div className="rounded-2xl border border-[#2A3655] bg-[#141B2D] p-5">
          <h2 className="font-display font-semibold text-[#F8FAFC]">2. Come preferisci scambiare?</h2>
          <div className="mt-3 flex flex-col gap-2">
            {MODES.map(([v, l]) => (
              <label key={v} className="flex items-center gap-2 text-sm text-[#CBD5E1]" data-testid={`onb-mode-${v}`}>
                <Checkbox checked={modes.includes(v)} onCheckedChange={() => toggle(modes, setModes, v)} className="border-[#2A3655] data-[state=checked]:bg-[#7C3AED]" />{l}
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <Button onClick={() => finish(true)} disabled={loading} data-testid="onb-add-card" className="bg-[#7C3AED] hover:bg-[#6D28D9]">Aggiungi la prima carta</Button>
        <Button onClick={() => finish(false)} disabled={loading} variant="outline" data-testid="onb-finish" className="border-[#2A3655] bg-transparent text-[#F8FAFC] hover:bg-[#1C2640]">Vai alla dashboard</Button>
        <Button onClick={() => nav("/dashboard")} variant="ghost" data-testid="onb-skip" className="text-[#94A3B8]">Salta</Button>
      </div>
    </div>
  );
}
